const { Loader } = require("@googlemaps/js-api-loader");
const container = document.getElementById("gmap");
if (container) {
	// console.table(container.dataset);
	const latlng = {
		lat: parseFloat(container.dataset.lat),
		lng: parseFloat(container.dataset.lng),
	};
	const mapOptions = {
		center: latlng,
		zoom: parseInt(container.dataset.zoom),
		language: "ja",
		region: "JP",
	};
	new Loader({
		apiKey: container.dataset.apiKey,
		version: "weekly",
	})
		.load()
		.then((google) => {
			const gmap = new google.maps.Map(container, mapOptions);
			new google.maps.Marker({
				position: latlng,
				map: gmap,
				title: container.dataset.venue,
			});
		})
		.catch((e) => {
			console.log(e);
		});
}
